import React from 'react';
import PropTypes from 'prop-types';

import * as FocusContentStyles from '../../../styles/widgets/focus-content.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Embedded } from './embedded/Embedded';
import { toExternalUrl } from '../../../utils/utils';
import AppButton from '../AppButton';
import { altNN } from '../../../utils/parsing';
import clsx from 'clsx';

const FocusContent = ({
  elem,
  playingVideoIndex,
  setPlayingVideoIndex,
  index,
  row,
  column
}) => {
  const {
    title,
    content,
    cover,
    video,
    link,
    link_text,
    new_window,
  } = elem;
  const nbrLineMid = Math.floor(row / 2);
  const handleClick = () => {
    if (typeof window !== 'undefined')
      window.open(toExternalUrl(link), (new_window === true) ? '_blank' : '_self');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (typeof window !== 'undefined')
        window.open(toExternalUrl(link), (new_window === true) ? '_blank' : '_self');
    }
  };
  return (
    <div className={FocusContentStyles.root}
      data-cy="focus-content-container"
    >
      {(cover || video) &&
        <div
          className={FocusContentStyles.imgContainer}
          style={{
            gridRow: row % 2 ? `1 / ${Math.ceil(row / 2)}` : `1 / ${Math.ceil(row / 2) + 1}`,
            paddingBottom: `calc((100% / ${column}) * ${nbrLineMid})`,
            gridColumn: row === 1 ? `1 / ${Math.ceil(row / 2) + 1}` : '1 / -1'
          }}
        >
          {cover &&
            <GatsbyImage
              alt={altNN('')}
              className={FocusContentStyles.image}
              image={getImage(cover.imageFile)}
              loading="eager"
              style={{ height: '100%', width: '100%' }}
              title={cover.name || ''}
            />
          }
          {!cover && video &&
            <Embedded
              contentUrl={video}
              index={index}
              playingVideoIndex={playingVideoIndex}
              setPlayingVideoIndex={setPlayingVideoIndex}
            />
          }
        </div>
      }
      <div
        style={{
          gridRow: row % 2 ? `${Math.ceil(row / 2)} / -1` : `${Math.ceil(row / 2) + 1} / -1`,
          paddingBottom: `calc((100% / ${column}) * (${cover ? nbrLineMid : row}))`,
          gridColumn: row === 1 ? `${Math.ceil(row / 2) + 1} / -1` : '1 / -1'
        }}
      />
      <div
        className={
          clsx(FocusContentStyles.innerContainer, {[FocusContentStyles.innerContainerNoImg]: !cover && !video
          })
        }
        style={{
          gridRow: row % 2 ? `${Math.ceil(row / 2)} / -1` : `${Math.ceil(row / 2) + 1} / -1`,
          gridColumn: row === 1 ? `${Math.ceil(row / 2) + 1} / -1` : '1 / -1'
        }}
      >
        <p className={FocusContentStyles.title}>
          {title}
        </p>
        <p className={clsx(FocusContentStyles.content, {[FocusContentStyles.contentNoImg]: !cover && !video})}>
          {content}
        </p>
        <AppButton
          color="secondary"
          dataCy={'focus-content-button'}
          id={title}
          label={link_text}
          noBorder
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          padding={10}
          tabIndex="0"
          variant="contained"
          width="80%"
        >
          <p className={clsx(FocusContentStyles.labelButton, {[FocusContentStyles.blank]: new_window})}>{link_text}</p>
        </AppButton>
      </div>
    </div>
  );
};

FocusContent.propTypes = {
  column: PropTypes.number,
  elem: PropTypes.shape({
    content: PropTypes.string.isRequired,
    cover: PropTypes.object,
    link: PropTypes.string.isRequired,
    link_text: PropTypes.string.isRequired,
    new_window: PropTypes.bool,
    title: PropTypes.string.isRequired,
    video: PropTypes.string,
  }),
  index: PropTypes.number,
  playingVideoIndex: PropTypes.number,
  row: PropTypes.number,
  setPlayingVideoIndex: PropTypes.func
};

export default FocusContent;
